export default "/assets/images/mila-feed-11-thumbnail.jpg?baf3ee68781a16df7ba6a1f5de9dfe57";